import React, { Component, Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ModalContainer } from 'react-router-modal';
import { connect } from 'react-redux';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Routes from '../Routes';
import LoginLayout from './Login';
import Login from '../Pages/Login';
import EditPassword from '../Pages/EditPassword';
import ResetPassword from '../Pages/ResetPassword';
import { verifyTokenAction } from '../../actions/session';
import Unicef from '../Pages/Unicef';

class Layout extends Component {

    componentDidMount() {
        const { token, verifyTokenAction } = this.props;
        if (token) {
            verifyTokenAction();
        }
    }

    render() {
        const { authenticated } = this.props;

        if (!authenticated) {
            return (
                <BrowserRouter>
                    <LoginLayout>
                        <Switch>
                            <Route exact path="/senha" component={ResetPassword} />
                            <Route exact path="/senha/:token" component={EditPassword} />
                            <Route exact path="/unicef" component={Unicef} />
                            <Route exact path="/*" component={Login} />
                        </Switch>
                    </LoginLayout>
                </BrowserRouter>
            );
        }

        return (
            <BrowserRouter>
                <Fragment>
                    <Sidebar />
                    <div className="main-content">
                        <Topbar />
                        <Routes />
                    </div>
                    {/* <ModalContainer /> */}
                </Fragment>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state) => ({
    authenticated: state.session.authenticated,
    token: state.session.token
});

const mapDispatchToProps = {
    verifyTokenAction
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);


// WEBPACK FOOTER //
// ./src/components/Layout/index.js